<template>
  <div class="notification-center">
    <template v-for="(notification, idx) in listNotifications">
      <div class="notificaction-center__notification success" :key="idx">
        <div class="notification-center__notification__text">

          <span>{{notification}}</span>

        </div>
        <a class="notification-center__notification__close" @click="removeNotification(idx)">
        </a>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      listNotifications: state => state.notifications.listNotifications
    })
  },
  methods: {
    removeNotification(idx) {
      this.$store.dispatch('removeNotification', idx)
    }
  }
}
</script>
